// 건물 능력치 — docs/GAME_DESIGN.md 5장 (기본 9종 + 왕국 시대 맹세의 성소 + 조선소 + 그리폰 둥지)
// size: 정사각형 풋프린트 한 변의 타일 수, pop: 완성 시 늘어나는 인구 상한
// sight: 완성된 건물의 시야 (풋프린트 중심에서 잰 타일 수, 짓는 중에는 FOUNDATION_SIGHT)

export const BUILDINGS = Object.freeze({
  keep: {
    id: 'keep',
    name: '영주관',
    age: 1,
    size: 4,
    cost: { gold: 400, wood: 400, mana: 0 },
    buildTime: 90,
    hp: 2400,
    sight: 10,
    pop: 10,
    dropoff: ['gold', 'wood'],
    trains: ['peasant'],
    unique: true, // 한 사람에 하나: 새로 짓지도 팔지도 못한다. 무너지면 그 자리에서 진다
  },
  farmstead: {
    id: 'farmstead',
    name: '농가',
    age: 1,
    size: 2,
    cost: { gold: 0, wood: 60, mana: 0 },
    buildTime: 20,
    hp: 400,
    sight: 5,
    pop: 8,
    hotkey: 'Q',
  },
  storehouse: {
    id: 'storehouse',
    name: '보급 창고',
    age: 1,
    size: 2,
    cost: { gold: 0, wood: 100, mana: 0 },
    buildTime: 25,
    hp: 600,
    sight: 6,
    dropoff: ['gold', 'wood'],
    hotkey: 'W',
  },
  barracks: {
    id: 'barracks',
    name: '병영',
    age: 1,
    size: 3,
    cost: { gold: 50, wood: 150, mana: 0 },
    buildTime: 40,
    hp: 1000,
    sight: 7,
    trains: ['pikeman', 'longbowman', 'royal_guard'],
    hotkey: 'E',
  },
  stables: {
    id: 'stables',
    name: '마구간',
    age: 1,
    size: 3,
    cost: { gold: 100, wood: 200, mana: 0 },
    buildTime: 45,
    hp: 1100,
    sight: 7,
    trains: ['scout_rider', 'knight'],
    hotkey: 'R',
  },
  obelisk: {
    id: 'obelisk',
    name: '룬 오벨리스크',
    age: 1,
    size: 2,
    cost: { gold: 50, wood: 150, mana: 0 },
    buildTime: 30,
    hp: 500,
    sight: 6,
    onWell: true,
    hotkey: 'A',
  },
  watchtower: {
    id: 'watchtower',
    name: '감시탑',
    age: 1,
    size: 2,
    cost: { gold: 100, wood: 100, mana: 0 },
    buildTime: 35,
    hp: 700,
    sight: 11,
    attack: { damage: 14, type: 'pierce', range: 7, cooldown: 1.5 },
    hotkey: 'S',
  },
  mage_tower: {
    id: 'mage_tower',
    name: '마법사의 탑',
    age: 2,
    size: 3,
    cost: { gold: 150, wood: 150, mana: 50 },
    buildTime: 50,
    hp: 900,
    sight: 8,
    trains: ['battlemage'],
    hotkey: 'Z',
  },
  market: {
    id: 'market',
    name: '시장',
    age: 2,
    size: 3,
    cost: { gold: 50, wood: 250, mana: 0 },
    buildTime: 45,
    hp: 1000,
    sight: 7,
    market: true,
    hotkey: 'X',
  },
  sanctum: {
    id: 'sanctum',
    name: '맹세의 성소',
    age: 3,
    size: 4,
    cost: { gold: 300, wood: 300, mana: 300 },
    buildTime: 80,
    hp: 2000,
    sight: 8,
    trains: ['solarion', 'etheria', 'arkanon'], // 맺은 맹세의 유닛만 뽑을 수 있다
    oathAltar: true,
    hotkey: 'C',
  },
  shipyard: {
    id: 'shipyard',
    name: '조선소',
    age: 1,
    size: 3,
    cost: { gold: 0, wood: 180, mana: 0 },
    buildTime: 45,
    hp: 1200,
    sight: 8,
    trains: ['war_galley', 'transport_ship', 'catapult_ship'],
    coastal: true, // 바다와 이어진 물에 두 칸 이상 닿아야 한다 (rules/placement.js)
    hotkey: 'V',
  },
  aerie: {
    id: 'aerie',
    name: '그리폰 둥지',
    age: 2,
    size: 3,
    cost: { gold: 150, wood: 200, mana: 100 },
    buildTime: 55,
    hp: 1000,
    sight: 9,
    trains: ['falcon_scout', 'gryphon_rider', 'storm_wyvern'],
    hotkey: 'F',
  },
});

/** 건물 하나의 생산 대기열 최대 길이 */
export const PRODUCTION_QUEUE_MAX = 5;

/** 건물을 팔면 돌려받는 몫: 비용 × 이 비율 × 남은 체력 비율 (rules/costs.js의 sellRefund) */
export const SELL_REFUND = 0.5;

/** 스냅샷에서 건물 종류를 숫자로 보낼 때 쓰는 순서 */
export const BUILDING_TYPES = Object.freeze(Object.keys(BUILDINGS));

/** 농노 명령 카드에 나오는 건설 목록 순서 (영주관은 없다: 시작할 때 하나뿐이다) */
export const BUILD_MENU = Object.freeze([
  'farmstead',
  'storehouse',
  'barracks',
  'stables',
  'obelisk',
  'watchtower',
  'mage_tower',
  'market',
  'sanctum',
  'shipyard',
  'aerie',
]);
